<template>
  <div class="wqb-box" v-if="data">
    <div class="wqb-asset-card">
      <div class="wqb-asset-header">
        <span class="wqb-asset-title">{{$t('all.zongzichanguzhi')}}</span>
        <!-- <span class="wqb-asset-link">{{$t('all.liushuijilu')}}</span> -->
      </div>
      <div class="wqb-asset-amount">{{data.valuationAmount}} {{data.toName}}</div>
    </div>
    <div class="wqb-currency-list">
      <div class="wqb-currency-item" v-for="(item, index) in data.walletList" :key="index" @click="handleGoDetail(item)">
        <div class="wqb-currency-icon">
          <img :src="item.currencyLogo" alt="" />
        </div>
        <div class="wqb-currency-info">
          <span class="wqb-currency-name">{{item.currencyName}}</span>
          <span class="wqb-currency-detail">{{$t('all.keyong')}} {{item.sumAvailableAmount}} {{$t('all.dongjie')}} {{item.sumFreezeAmount}}</span>
        </div>
        <div class="wqb-currency-arrow">
          <img src="../../../assets/image/jinru_14@2x.png" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getUserWalletList } from "@/api/qianbao";
export default {
  data() {
    return {
      data:''
    };
  },
  mounted() {
  	this.getUserWalletList()
  },
  methods: {
	async getUserWalletList(){
		const res = await getUserWalletList({queryValuationAmount:1})
		this.data = res.data
	},
    handleGoDetail(data) {
	  console.log(11)
      this.$router.push({ path: '/wodequanbao',query: {
        currencyId: data.currencyId
      }});
    },
	
  }
};
</script>

<style scoped lang="scss">
.wqb-box {
  height: calc(100vh - 130px);
  display: flex;
  flex-direction: column;
  align-items: center;
}

.wqb-asset-card {
  margin-top: 40px;
  background: linear-gradient( 84deg, #153D66 0%, #340051 88.07%);
  border-radius: 20px 20px 20px 20px;
  padding: 24px;
  width: 600px;
}

.wqb-asset-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.wqb-asset-title {
  font-family: MiSans, MiSans;
  font-weight: 400;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.6);
}

.wqb-asset-link {
  font-family: MiSans, MiSans;
  font-weight: 400;
  font-size: 14px;
  color: #6BEAA9;
  cursor: pointer;
}

.wqb-asset-amount {
  font-family: MiSans, MiSans;
  font-weight: 600;
  font-size: 48px;
  color: #ffffff;
}

.wqb-currency-list {
  
}

.wqb-currency-item {
  display: flex;
  align-items: center;
  padding: 14px 20px;
  cursor: pointer;
  transition: background 0.2s;
  width: 600px;
  background: rgba(255,255,255,0.1);
  border-radius: 20px 20px 20px 20px;
  margin-top: 20px;
  cursor: pointer;
}

.wqb-currency-icon {
  width: 40px;
  height: 40px;
  margin-right: 16px;

  img {
    width: 40px;
    height: 40px;
    border-radius: 50%;
  }
}

.wqb-currency-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.wqb-currency-name {
  font-family: MiSans, MiSans;
  font-weight: 500;
  font-size: 16px;
  color: #ffffff;
}

.wqb-currency-detail {
  font-family: MiSans, MiSans;
  font-weight: 400;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.5);
}

.wqb-currency-arrow {
  img {
    width: 20px;
    height: 20px;
    opacity: 0.5;
  }
}
</style>


// WEBPACK FOOTER //
// wodeqianbao.vue?52bc5058